import { SignalClientService } from '@rightship-tech/common-ui/services/basic/signal-client.service';
import { TabModel } from '@rightship-tech/common-ui/models/basic.models';
import { SignalFunctions } from '../../../../constants/signal.constants';
import { VesselApi } from '../../../../apis/vessel.api';
import { RouteConfig } from 'aurelia-router';
import { SafetyRatingApi } from '../../../../apis/safety-rating.api';

export abstract class BaseRatingEntity<T> {

    public item: T;
    public tabs: TabModel[] = [];
    public idPropertyName: string = "id";
    protected _routeConfig: RouteConfig;
    protected _params;
    
    constructor(protected signalClientService: SignalClientService, protected vesselApi: VesselApi, protected safetyRatingApi: SafetyRatingApi) {}

    public activate(params: any, routeConfig: RouteConfig): Promise<void> {
        // this is done like this because of this bug
        // 4489 Individual - cannot create a new individual if i have an individual already opened
        this._params = params;
        this._routeConfig = routeConfig;
        const id: number = Number(params[this.idPropertyName]);
        return this.getEntity(id);
    }

    attached() {
        this.signalClientService.subscribe(SignalFunctions.systemRuleChanged, this.refreshRating);
    }

    detached() {
        this.signalClientService.unsubscribe(SignalFunctions.systemRuleChanged, this.refreshRating);
    }

    public getEntity(id: number) {
        this.tabs = [];
        return new Promise<void>((resolve, reject) => {
            this.getEntityInternal(id, (x) => {
                resolve(x);
            }, reject);
        });
    }

    protected getEntityInternal(id: number, resolve: any, reject: any) {
        if (id && id > 0) {
            this.getExistingEntity(id, resolve, reject);
        } 
    }

    protected getExistingEntity(id: number, resolve: any, reject: any) {
        this.getItem(Number(id))
            .then((response: T) => {
                this.item = response;
                this.refreshTabs().then(() => {
                        resolve();
                }).catch(() => { reject(); });
            }).catch(() => { reject(); });
    }

    public refreshTabs() {
        return new Promise<void>((resolve) => {                           
            this.tabs = [];

            setTimeout(() => {
                const getTabsResponse = this.getTabs();
                if (getTabsResponse instanceof Promise) { 
                    getTabsResponse.then(tabs => {
                        this.tabs = tabs;
                        resolve();
                    });
                } else {
                    this.tabs = getTabsResponse;
                    resolve();
                }
            });            
        })
    }

    protected abstract getItem(id: number): Promise<T>;

    protected abstract getItemId(): number;

    protected abstract getTabs(): TabModel[] | Promise<TabModel[]>;

    private refreshRating = async (param) => {
        if (this.item && Object.prototype.hasOwnProperty.call(this.item, "vesselId") && param && param.vesselIds && param.vesselIds.filter(x => x == this.item["vesselId"]).length >= 1) {
            try {
                const response = await this.safetyRatingApi.getRatingsModel(this.item["vesselId"]);
                
                if(Object.prototype.hasOwnProperty.call(this.item, "starRating"))
                    this.item["starRating"] = response.starRating;
                if(Object.prototype.hasOwnProperty.call(this.item, "rating"))
                    this.item["rating"] = response.rating;
                if(Object.prototype.hasOwnProperty.call(this.item, "systemRuleLastExecutedStatus"))
                    this.item["systemRuleLastExecutedStatus"] = response.systemRuleLastExecutedStatus;
                if(Object.prototype.hasOwnProperty.call(this.item, "ratingPlus"))
                    this.item["ratingPlus"] = response.ratingPlus;
                if(Object.prototype.hasOwnProperty.call(this.item, "isRatingVerified"))
                    this.item["isRatingVerified"] = response.isVerified;
                if(Object.prototype.hasOwnProperty.call(this.item, "safetyRatingType"))
                    this.item["safetyRatingType"] = response.safetyRatingType;
            } catch (e) {
                console.log("Failed to download doc fleet", e);
            }
        }
    }
}
